import React from 'react';
import { SalesPage } from './components/SalesPage';
export function App() {
  return <div className="min-h-screen bg-gaming-bg text-gray-200 font-sans selection:bg-gaming-purple selection:text-white overflow-hidden" data-id="element-0">
      <SalesPage data-id="element-1" />
    </div>;
}